import { ReactNode } from 'react';

interface VerificationModalHeaderProps {
  icon: ReactNode;
  title: string;
  description?: string;
}

export const VerificationModalHeader = ({
  icon,
  title,
  description,
}: VerificationModalHeaderProps) => {
  return (
    <div className="flex flex-col items-center text-center gap-2 max-w-screen-xs mx-auto">
      <div className="p-6 bg-background-quaternary rounded-full text-primary mx-auto mb-2">
        {icon}
      </div>
      <h2 className="text-primary font-semibold sm:text-2xl text-xl">
        {title}
      </h2>
      {description && <div className="text-foreground">{description}</div>}
    </div>
  );
};
